export const SET_COMPANY_DATA = 'SET_COMPANY_DATA';
export const SET_SINGLE_COMPANY_DATA = 'SET_SINGLE_COMPANY_DATA';
export const ADD_COMPANY_DATA = 'ADD_COMPANY_DATA';
export const DELETE_COMPANY_DATA = 'DELETE_COMPANY_DATA';
export const ADD_COMPANY_IMAGE = 'DELETE_COMPANY_IMAGE';
export const SET_COMPANY_FREECREDIT = 'SET_COMPANY_FREECREDIT';




// WEBPACK FOOTER //
// ./src/store/modules/company/action-types.js